import client from "./client";

const register = (userInfo) => client.post("/users", userInfo);
const setDeviceDetails = (appVersion, modelName) => client.put("/users/setDeviceDetails", { appVersion: appVersion, modelName: modelName });
const getUsers = () => client.get("/users");
const getUser = (userID) => client.get("/users/getUser/" + userID);

const setNotificationRange = (range) => client.post("/users/setNotificationRange", { notificationRange: range });
const setPushToken = (pushToken) => client.post("/users/setPushToken", { token: pushToken });
const removePushToken = () => client.put("/users/removePushToken");
const setLocation = (location) => client.post("/users/setLocation", { location: location });
const addSubscription = (userID, subscription) => client.post("/users/addSubscription", { userID: userID, subscription: subscription });
const removeSubscription = (userID, subscription) => client.post("/users/removeSubscription", { userID: userID, subscription: subscription });
const sendPushNotification = (messageInfo) => client.post("/users/sendPushNotification", messageInfo);
const sendMessage = (messageInfo) => client.post("/users/sendMessage", messageInfo);
const findNearestAgent = (postcode) => client.post("/users/findNearestAgent", postcode);
const validatePostcode = (postcode) => client.post("/users/validatePostcode", postcode);
const setType = (userID, type) => client.post("/users/setType", { userID, type });
const setEnabled = (userID, status) => client.put("/users/setEnabled", { userID, status });
const setVehicleNotificationsEnabled = (userID, status) => client.put("/users/setVehicleNotificationsEnabled", { userID, status });
const setPartRequestNotificationsEnabled = (userID, status) => client.put("/users/setPartRequestNotificationsEnabled", { userID, status });
const setInStockNotificationsEnabled = (userID, status) => client.put("/users/setInStockNotificationsEnabled", { userID, status });
const setAwaitingRemovalNotificationsEnabled = (userID, status) => client.put("/users/setAwaitingRemovalNotificationsEnabled", { userID, status });
const setVehicleAwaitingContactNotificationsEnabled = (userID, status) => client.put("/users/setVehicleAwaitingContactNotificationsEnabled", { userID, status });

export default {
    register,
    setDeviceDetails,
    setNotificationRange,
    addSubscription,
    removeSubscription,
    setPushToken,
    setLocation,
    getUsers,
    getUser,
    sendPushNotification,
    findNearestAgent,
    validatePostcode,
    sendMessage,
    setType,
    removePushToken,
    setEnabled,
    setVehicleNotificationsEnabled,
    setVehicleAwaitingContactNotificationsEnabled,
    setPartRequestNotificationsEnabled,
    setInStockNotificationsEnabled,
    setAwaitingRemovalNotificationsEnabled,
};
